
import api from '../../api/index';
import Alert from 'vux/src/components/alert/index.vue'

export default {
components: {
Alert
},
props: ['scissorBeforeUpload', 'pageLimit', 'typeLimit', 'sizeLimit', 'autoCropSize', 'crfcode', 'baseURL', 'files'],
name: "frhomoloImageView",
data() {
return {
uploadHeader: {},
fileList: [],
tempFile: null,
option: {
img: '', // 图片源
info: true, // 裁剪框的大小信息
outputSize: 1, // 裁剪生成图片质量
outputType: '', // 裁剪生成图片格式
full: true, // 是否输出原图比例的截图
canMove: true, // 图片是否能移动
canMoveBox: true, // 截图框是否能移动
fixedBox: false, // 是否固定截图框宽高固定比例
original: false, // 上传图片按照原始比例渲染
autoCrop: true, // 是否默认生成截图框
autoCropWidth: 300, // 默认生成截图框宽度
autoCropHeight: 300, // 默认生成截图框高度
centerBox: true, // 截图框是否被限制在图片里面
infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
enlarge: 1 
},
cutImage: false,
previewerList: [],
currentIndex: 0,
optionsfn: {
isClickableElement: function (el) {
return /frhomolo-icon-pic/.test(el.className)
}
},
showAlert: false,
alertContent: {
title: '',
content: ''
},
showUpload: true
}
},
methods: {
cancelUpload() {
this.cutImage = false;
this.tempFile = null;
},
rotateUpload() {
this.$refs.frhomoloCropper.rotateRight()
},
cutUpload() {
this.$refs.frhomoloCropper.getCropBlob((data) => {
let file = new File([data], this.tempFile.name || '', {type: this.tempFile.type});
this.uploadImage(file);
})
},
uploadFile(e) {
let file = e.target.files[0];
if (!file.type.startsWith('image/')) {
this.alertContent = {
title: '警告',
content: '请上传图片类型文件'
}
this.showAlert = true;
return;
}
if (this.sizeLimit && file.size / 1024 > this.sizeLimit) {
let largeSize = this.sizeLimit >= 1024 ? parseInt(this.sizeLimit / 1024) + 'M' : this.sizeLimit + 'k';
this.alertContent = {
title: '警告',
content: '请上传' + largeSize + '大小以下文件'
}
this.showAlert = true;
return;
}
if (this.typeLimit) {
let type = file.type.split('/');
let typeLimits = this.typeLimit.split('/');
let flag = false;
typeLimits.forEach(e => {
if (e === type[1]) {
flag = true;
}
})
if (!flag) {
this.alertContent = {
title: '警告',
content: '请上传' + this.typeLimit + '格式文件'
}
this.showAlert = true;
return;
}
}
if (!this.scissorBeforeUpload) {
this.uploadImage(file);
} else {
this.tempFile = file;
const reader=new FileReader();
reader.onloadend = url => {
this.option.outputType = this.tempFile.type || 'png';
this.option.img = reader.result;
this.cutImage = true;
}
reader.readAsDataURL(file);
}
},
uploadImage(file) {
if (this.pageLimit && this.pageLimit >= this.fileList.length + 1) {
this.showUpload = false
}
let baseUrl = this.baseURL || '';
let form = new FormData();
form.set('file', file);
api.sendImage(this.crfcode, form, baseUrl).then(res => {
if (res.status === 200 && res.data.success) {
this.fileList.push(res.data);
this.previewerList.push({
src: baseUrl + res.data.url
})
this.cutImage = false;
this.tempFile = null;
} else {
this.showUpload = true;
}
}).catch(err => {
this.showUpload = true;
this.alertContent = {
title: '警告',
content: '上传失败请重新上传'
}
this.showAlert = true;
this.cutImage = false;
console.log(err);
})
},
delImage(e, item, index) {
e.stopPropagation();
this.previewerList.splice(index, 1);
this.fileList.splice(index, 1);
this.showUpload = true;
},
showUploadImage(e, i) {
e.stopPropagation();
this.$refs.frhomoloPreviewer.show(i);
this.currentIndex = i;
},
logIndexChange (arg) {
this.currentIndex = arg.currentIndex;
},
prePreviewer(e) {
e.stopPropagation();
if (this.currentIndex > 0) {
this.$refs.frhomoloPreviewer.prev();
} else {
return false;
}
},
nextPreviewer(e) {
e.stopPropagation();
if (this.currentIndex < this.previewerList.length - 1 && this.previewerList.length > 0) {
this.$refs.frhomoloPreviewer.next();
} else {
return false;
}
},
setAutoCropSize() {
this.autoCropSize.forEach((e, i) => {
switch(i) {
case 0:
this.option.autoCropWidth = e;
break;
case 1:
this.option.autoCropHeight = e;
break;
}
})
},
setFileList() {
this.fileList = JSON.parse(JSON.stringify(this.files));
}
},
watch: {
crfcode() {
if (this.crfcode && this.crfcode.length >= 1) {
this.uploadHeader = {
'X-CSRF-TOKEN': this.crfcode
}
}
},
autoCropSize() {
this.setAutoCropSize();
}
},
computed: {},
created() {
this.setAutoCropSize();
if (this.files && this.files.length > 0) {
this.setFileList();
}
},
mounted() {
}
};
